interface RequestConfig {
  baseUrl: string;
  socketUrl: string;
  socketPath: string;
  slackUrl: string;
  exchangeBaseUrl: string;
}

let requestConfig: RequestConfig = {
  baseUrl: "https://api.zania.app/frontend/dev",
  socketUrl: "wss://api.zania.app",
  slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
  socketPath: "/internal/dev/socket/",
  exchangeBaseUrl: "https://dev.exchange.zania.app",
};

switch (import.meta.env.MODE) {
  case "demo": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend/staging",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/staging/socket/",
      exchangeBaseUrl: "https://staging.exchange.zania.app",
    };
    break;
  }
  case "production": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot/v0/slack/install",
      socketPath: "/internal/socket/",
      exchangeBaseUrl: "https://exchange.zania.app",
    };
    break;
  }
  case "staging": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend/staging",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/staging/socket/",
      exchangeBaseUrl: "https://staging.exchange.zania.app",
    };
    break;
  }
  case "development": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend/dev",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/dev/socket/",
      exchangeBaseUrl: "https://dev.exchange.zania.app",
    };
    break;
  }
  case "localhost": {
    requestConfig = {
      baseUrl: "http://localhost:8000",
      socketUrl: "ws://localhost:8000",
      slackUrl: "http://localhost:8000/slack-bot-staging/v0/slack/install",
      socketPath: "",
      exchangeBaseUrl: "https://dev.exchange.zania.app",
    };
    break;
  }
}

export default requestConfig;
